module.exports = __webpack_public_path__ + "static/media/search.d0f1c0ad.svg";